import { render, staticRenderFns } from "./storesTable.vue?vue&type=template&id=628ca682&scoped=true&"
import script from "./storesTable.vue?vue&type=script&lang=js&"
export * from "./storesTable.vue?vue&type=script&lang=js&"
import style0 from "./storesTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./storesTable.vue?vue&type=style&index=1&id=628ca682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628ca682",
  null
  
)

component.options.__file = "storesTable.vue"
export default component.exports